import { createContext } from 'react';
/**
 * Holds the current scope node (or null if no scope mounted). Each
 * `InstrumentationScope` provider pushes a new node pointing to its parent.
 *
 * Registered globally so HMR / multiple module loads can't produce duplicate
 * context instances.
 */
export const ScopeContext = createContext(null);
ScopeContext.displayName = 'InstrumentationScopeContext';
//# sourceMappingURL=ScopeContext.js.map